import React from 'react'
import { connect } from 'react-redux'

import {
  getLocalStorage,
  setLocalStorage,
  deleteLocalStorage
} from '../helpers/LocalStorage'

import {
  toggleSettings
} from '../store/actions/settingsAction'

import Select from '../ui/Select'
import Label from '../ui/Label'
import Icon from '../ui/Icon'

class Settings extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      ptpOptions:[
        {value:1,display:'1'},
        {value:2,display:'2'},
        {value:3,display:'3'},
        {value:4,display:'4'},
        {value:5,display:'5'}
      ],
      option:{
        ptp:getLocalStorage('ptpTime') ? getLocalStorage('ptpTime') : 1
      }
    }
  }

  changePtpTime(data){
    const ptpTime = data.event.target.value
    this.setState({
      setOptions:{
        ptp:ptpTime
      }
    })
  }

  closeSettings(){
    this.props.dispatch(toggleSettings(false))
  }

  render(){
    const {
      ptpOptions,
      option
    } = this.state
    return (
      <div className={`settings-wrapper ${this.props.isActive && 'active'}`}>
        <div className="settings-header">
          Settings
          <Icon name="close" action={() => this.closeSettings()}/>
        </div>
        <Label 
          name="ptp-time"
          label="Push to Play Time"/>
        <Select 
          name="ptp-time"
          options={ptpOptions} 
          selected={option.ptp}
          action={(data) => this.changePtpTime(data)}/>
      </div>
    )
  }
}

export default connect()(Settings)


// WEBPACK FOOTER //
// ./src/components/Settings.js